import React from "react";
import { Skeleton, Flex, Grid, Table } from "@mantine/core";
import { Section } from "../Container/Section";
import { SectionTitleWithExp } from "../customTypo/SectionTitleWithExp";
import { CardContainerRetro } from "../Container/CardContainerRetro";
import colorsCustom from "../../designTokens/colorsCustom";
import colors from "../../designTokens/colors";

export const TableSkeleton = ({ isMobile, title }) => {
	return (
		<Section>
			<SectionTitleWithExp
				title={title}
				isMobile={isMobile}
			/>
			<CardContainerRetro 
				p={isMobile ? "16 0" : "24 0"} 
				w={"100%"} 
				bg={colorsCustom.paper} 
				weight="bold" 
				rd={16}
			>
				<Flex direction={"column"} gap={isMobile ? 8 : 16} w={"100%"}>
					<Grid gutter={0}>
						<Grid.Col
							span={isMobile ? 12 : 6}
							style={{ 
								borderRight: !isMobile ? `0.5px solid ${colors.gray[3]}` : 'none',
								borderBottom: isMobile ? `0.5px solid ${colors.gray[3]}` : 'none'
							}}
						>
							<Flex
								p={isMobile ? "16" : "24"}
								direction="column"
								justify={"center"}
								gap={16}
								style={{
									height: "100%",
									overflow: 'auto'
								}}
							>
								<Table>
									<Table.Thead>
										<Table.Tr>
											<Table.Th>
												<Skeleton height={isMobile ? 14 : 18} width={50} />
											</Table.Th>
											<Table.Th>
												<Skeleton height={isMobile ? 14 : 18} width={60} />
											</Table.Th>
											<Table.Th>
												<Skeleton height={isMobile ? 14 : 18} width={50} />
											</Table.Th>
											<Table.Th>
												<Skeleton height={isMobile ? 14 : 18} width={60} />
											</Table.Th>
											<Table.Th>
												<Skeleton height={isMobile ? 14 : 18} width={70} />
											</Table.Th>
										</Table.Tr>
									</Table.Thead>
									<Table.Tbody>
										{[1, 2, 3].map((index) => (
											<Table.Tr key={index}>
												<Table.Td>
													<Skeleton height={isMobile ? 14 : 18} width={30} />
												</Table.Td>
												<Table.Td>
													<Skeleton height={isMobile ? 14 : 18} width={50} />
												</Table.Td>
												<Table.Td>
													<Skeleton height={isMobile ? 14 : 18} width={40} />
												</Table.Td>
												<Table.Td>
													<Skeleton height={isMobile ? 14 : 18} width={40} />
												</Table.Td>
												<Table.Td>
													<Skeleton height={isMobile ? 14 : 18} width={45} />
												</Table.Td>
											</Table.Tr>
										))}
									</Table.Tbody>
								</Table>
							</Flex>
						</Grid.Col>
						<Grid.Col span={isMobile ? 12 : 6}>
							<Flex
								p={isMobile ? "16" : "24"}
								direction="column"
								justify={"center"}
								gap={16}
								style={{
									height: "100%",
								}}
							>
								{/* Box Plot Skeleton */}
								{["views", "likes", "replies", "reposts"].map((metric) => (
									<Flex
										key={metric}
										direction="column"
										gap={8}
										w="100%"
									>
										<Flex justify="space-between" align="center">
											<Skeleton height={isMobile ? 14 : 16} width={80} />
											<Skeleton height={isMobile ? 14 : 16} width={60} />
										</Flex>
										<Flex align="center" gap={8}>
											<Skeleton height={isMobile ? 14 : 16} width={30} />
											<Flex
												style={{
													width: "100%",
													height: 16,
													position: "relative",
												}}
											>
												<Skeleton height={16} width="100%" radius="xs" />
											</Flex>
											<Skeleton height={isMobile ? 14 : 16} width={30} />
										</Flex>
									</Flex>
								))}
							</Flex>
						</Grid.Col>
					</Grid>
				</Flex>
			</CardContainerRetro>
		</Section>
	);
}; 